import React, { useState } from "react";
import Instance from "../../Services/Instance";
import config from "../../Services/config.js";
import SideBar from "../../Layouts/SideBar";
import "../../Assets/Styles/Products.css";
import "../../Assets/Styles/Blog.css";

function NewPost() {
    const [error, setError] = useState("");
    const [imagePreview, setImagePreview] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [newCategory, setNewCategory] = useState({
        name: "",
        description: "",
        order: "",
        isActive: true
    });

    const { name, description, order, isActive } = newCategory;

    const onInputChange = (e) => {
        setNewCategory({ ...newCategory, [e.target.name]: e.target.value });
    };

    const onCheckboxChange = (e) => {
        setNewCategory({ ...newCategory, [e.target.name]: e.target.checked });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("name", name);
            formData.append("description", description || "");
            formData.append("order", order || "");
            formData.append("isActive", isActive);
            
            // Ajouter l'image si elle a été sélectionnée
            if (imageFile) {
                formData.append("imgCatFaq", imageFile);
            }

            await Instance.post(`${config.api_url}/faq/categories`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            window.location = "/dashboard/blog";
        } catch (error) {
            console.error("Erreur lors de la création de catégorie:", error);
            setError(error);
        }
    };

    return (
    <>
    <SideBar />
    
        <div className='category-manager-container'>
            
            <div className="category-manager-content">
                <div className="category-manager-header">
                    <h2>Ajouter une nouvelle catégorie</h2>
                </div>
                <form onSubmit={(e) => handleSubmit(e)} className="form-card">
                    <div className="form-display">
                        <div className="form-group">
                            <label htmlFor="name">Nom de la catégorie</label>
                            <input
                                className="form-input"
                                value={name}
                                name="name"
                                type="text"
                                onChange={(e) => onInputChange(e)}
                                required={true}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="description">Description</label>
                            <textarea
                                className="form-input"
                                value={description}
                                name="description"
                                onChange={(e) => onInputChange(e)}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="order">Ordre</label>
                            <input
                                className="form-input"
                                value={order}
                                name="order"
                                type="number"
                                onChange={(e) => onInputChange(e)}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="imgCatFaq">Image de la catégorie</label>
                            <input
                                className="form-input"
                                name="imgCatFaq"
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                            {imagePreview && (
                                <div style={{ marginTop: '10px' }}>
                                    <img 
                                        src={imagePreview} 
                                        alt="Aperçu" 
                                        style={{ 
                                            maxWidth: '200px', 
                                            maxHeight: '200px',
                                            objectFit: 'cover',
                                            borderRadius: '8px'
                                        }} 
                                    />
                                </div>
                            )}
                        </div>

                        <div className="form-group">
                            <label htmlFor="isActive">
                                <input
                                    type="checkbox"
                                    name="isActive"
                                    checked={isActive}
                                    onChange={(e) => onCheckboxChange(e)}
                                />
                                {" "}Catégorie active
                            </label>
                        </div>
                    </div>

                    <div className="form-actions">
                        <button type="submit" className="btn-submit">Ajouter</button>
                    </div>
                </form>
            </div>
            {error && (
                <h1 style={{ color: "red", position: "fixed", left: "10%", bottom: "10%" }}>
                    {error.response?.data?.message || "Une erreur est survenue"}
                </h1>
            )}
        </div>
    </>
    );
}

export default NewPost;